<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMeta } from '@/stores/meta.js'

/**
 * An activity's priority beside its name (D-351): high an arrow up in red, low an arrow down in
 * blue, normal nothing. An entry of the dictionary may say its own icon and colour (meta.icon,
 * meta.color) — a priority the company added is shown so.
 */
const props = defineProps({ priority: { type: String, default: null } })
const { t } = useI18n()
const meta = useMeta()
const DEFAULTS = { high: { icon: 'fa-arrow-up', color: 'text-red-600 dark:text-red-400' }, low: { icon: 'fa-arrow-down', color: 'text-sky-600 dark:text-sky-400' } }
const shown = computed(() => {
  if (!props.priority) return null
  const entry = (meta.dictionary('activity_priority')?.entries || []).find((e) => e.key === props.priority)
  const own = entry?.meta?.icon ? { icon: entry.meta.icon, color: '', style: entry.meta.color ? { color: entry.meta.color } : null } : null
  const look = own || DEFAULTS[props.priority]
  return look ? { ...look, label: `${t('fields.activity.priority')}: ${entry ? meta.localized(entry.label) : props.priority}` } : null
})
</script>

<template>
  <i v-if="shown" :class="['fa-solid fa-fw shrink-0 text-xs', shown.icon, shown.color]" :style="shown.style" :title="shown.label" role="img" :aria-label="shown.label" :data-priority="priority" data-testid="priority-icon"></i>
</template>
